import { getJson, postJson } from './client';
import type { ListResponse, RecommendRequest, RecommendResponse } from '../types';

/** Fetch the full champion catalog. */
export function listChampions(): Promise<ListResponse> {
  return getJson<ListResponse>('/champions');
}

/** Fetch the distinct role tags, for the filter UI. */
export function listRoles(): Promise<string[]> {
  return getJson<string[]>('/champions/roles');
}

/** Ask the backend for recommended picks given the current draft state. */
export function getRecommendations(req: RecommendRequest): Promise<RecommendResponse> {
  return postJson<RecommendResponse>('/recommend', req);
}
